import React, { useEffect, Fragment } from 'react'
import { useHistory } from 'react-router-dom'
import { getParameterByName , getUrlParameter} from "../services/utils";
import config from '../config'
import { pureCloudService } from "../services/purecloud";
import constants from '../constants'
import backendAPI from '../services/backend'


const Main = () => {
    const history = useHistory()

    const fetchDisclaimerContent = async (tempToken) => {
        try {
            const disclaimerResponse = await backendAPI.getDisclaimerContent(tempToken);
            console.log(`PrivacyDisclaimer ${JSON.stringify(disclaimerResponse)}`);
            setConsentResponse(disclaimerResponse.consentSettings);
            sessionStorage.setItem(constants.SESSION_KEY_DISCLAIMER_RESPONSE, JSON.stringify(disclaimerResponse.consentSettings))
        } catch (error) {
            setError(`An error occured while fetching data:${JSON.stringify(error.message)}`)
            console.log(error)
        } finally {
            setIsWaitingModalOpen(false)
        }

    }

    const notifyUserLogin = async (tempToken) => {
        try {
            console.log("Calling notify user login")
            sessionStorage.setItem(constants.GC_TOKEN, tempToken);
            const notifyLoginResponse = await backendAPI.postUserLogin(tempToken);
            sessionStorage.setItem(constants.SESSION_KEY_USER_LOGIN_RESPONSE, JSON.stringify(notifyLoginResponse))
            sessionStorage.setItem(constants.SESSION_KEY_CONSENTAGREED, true);
            console.log(`notifyUserLogin ::: Notify user login response ${JSON.stringify(notifyLoginResponse)}`);
            //setLoginResponse(notifyLoginResponse)
            console.log('Navigating to Conversation Page')
            history.push("/conversations");
            
            //history.push("/management/users/");
            
        } catch (error) {
            //setError(`An error occured while fetching data:${JSON.stringify(error.message)}`)
            console.log(error)
        } finally {
            //setSendingLogin(false)
        }

    }

    useEffect(() => {        
        const init = async () => {
            console.log('main.useEffect.init')
            
            const urlParams = new URLSearchParams(window.location.search);
            
            const error = urlParams.get('error')
            console.log(error);
            let environment = urlParams.get('environment')            
            console.log(`Environment is ${environment}`);
            if(environment){
                sessionStorage.setItem(constants.GC_ENVIRONMENT,environment)
            }else{
                sessionStorage.setItem(constants.GC_ENVIRONMENT,config.defaultEnvironment);
            }
            

            const token = urlParams.get('token')
            console.log(`token: ${token}`);
            if (token){
                console.log(`moving to Disclaimer Page`);
                sessionStorage.setItem(constants.GC_TOKEN,getParameterByName(constants.GC_ACCESS_TOKEN));
                //fetchDisclaimerContent(token);
                notifyUserLogin(token);
                //history.push({ pathname: '/disclaimer', state: { token: token } })
                
            }else{
                console.log('Main.js:::Token is empty , Redirecting to Unauthorized Page.')
                history.push('/unauthorized');
            }            
            console.log(getParameterByName(constants.GC_ACCESS_TOKEN));

            if (getParameterByName(constants.GC_ACCESS_TOKEN)) {
                sessionStorage.setItem(constants.GC_TOKEN,getParameterByName(constants.GC_ACCESS_TOKEN));
            }
           if (sessionStorage.getItem(constants.GC_TOKEN)) {
                try {
                    console.log("Initialize");
                    // const organization = await getOrganization(sessionStorage.getItem(constants.GC_ENVIRONMENT), sessionStorage.getItem(constants.GC_TOKEN))
                    // await validateSubscription(organization.id, 'pureclouddatatables')

                    const loggedInUser = await pureCloudService.getCurrentUserDetails(
                        sessionStorage.getItem(constants.GC_ENVIRONMENT),
                        sessionStorage.getItem(constants.GC_TOKEN)
                    );
                    console.log(`Current logged in user is : ${JSON.stringify(loggedInUser)}`);
                    const divisionId = loggedInUser.division.id;
                    console.log("User division ID", divisionId);
                    sessionStorage.setItem(constants.GC_DIVISION_ID, divisionId);

                    const roles = await pureCloudService.getRoles(
                        sessionStorage.getItem(constants.GC_ENVIRONMENT),
                        sessionStorage.getItem(constants.GC_TOKEN),
                        loggedInUser.id
                    );
                    console.log("roles", roles);
                const isUser = roles.roles.find((r) => r.name === config.userRole)? true: false;

                console.log("isUser", isUser);

                if (isUser) {
                    history.push("/home");
                } else {
                    history.push("/unauthorized", "Unauthorized Genesys Cloud user");
                }
            }catch(error){
                console.log("Error : " + error);
                if (error.status === 401) {
                    //history.push("/unauthorized");
                }else{
                    history.push("/unauthorized", error.message);
                } 
            }
        }else{
               // history.push("/unauthorized");
        }};
        init()
    }, [history])

    return (<Fragment></Fragment>)
}

export default Main